'use client';
import qs from 'qs';
import { ClientApi } from './useApi';

const getNewUrl = ({ options }: Record<string, any>) => {
  if (window === undefined) return '';
  const url = new URL(window.location.href);
  const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const _newSearch = qs.stringify({ ...params, ...options });
  const newUrl = new URL(url.origin + url.pathname + '?' + _newSearch);
  return newUrl.href;
};

export const goLogin = () => {
  if (window === undefined) return;
  window.location.href = `/login?s_url=${encodeURIComponent(
    window.location.href
  )}`;
};

export const goValidateUrl = () => {
  if (window === undefined) return;
  const _newUrl = getNewUrl({ s_auto_validate_wj: '1' });
  window.location.href = `/login?s_url=${encodeURIComponent(_newUrl)}`;
};
interface RealNameParams {
  isPreview?: boolean;
  isSkip?: boolean;
  onSuccess?: () => void;
  onSkip?: () => void;
}
export const mobileRealNameUrl = (url: string, params?: RealNameParams) => {
  const { isSkip = true, isPreview = false } = params ?? {};
  const coralAppId = process.env.NEXT_PUBLIC_CORAL_APPID;
  const beaconId = process.env.NEXT_PUBLIC_DATONG_ID;
  const skip = isSkip ? 1 : 0;
  const preview = isPreview ? 1 : 0;

  return `/embed/page/mobile/realname_auth.html?s_appid=${coralAppId}&s_beacon=${beaconId}&s_skip=${skip}&s_preview=${preview}&s_url=${encodeURIComponent(
    url
  )}`;
};

export const validateInfo = async () => {
  const resp = await ClientApi.get<{ code: number; data: any; msg: string }>(
    '/openTechPortalWebAPI/techforgood/usercenter/current/user/detail',
    { isOnlyValidateReq: true, errorMessage: false }
  );
  if (resp?.code === 403) {
    return null;
  }
  return resp;
};

// 手机端登录
// 1.登录 --> 跳转到pc登录重定向手机端登录 --> url参数带s_from代表来自从手机端登录了 -->登录页跳转到目标地址 --> 获取用户信息走2
// 2. 用户信息获取 ---> 设置已登录；用户信息未获取 ---> 未登录(登录故障)
// 3. 是否打开过实名框 --> 未打开走4(跳转过realname.auth.html页面，或认为打开过pc端弹出过框，或已实名过)，已打开保持
// 4. 走实名框，设置已打开过 --> 跳转实名地址 --> 回跳到s_url地址
// 报名
// 6. 点击报名 --> 未登录 --> 走1（已登录) --> 点击-->跳转问卷
// 7. 点击报名 --> 已登录 --> 跳转到问卷.

// pc端登录
// 1.登录 -->登录页跳转到目标地址 --> 获取用户信息走2
// 2. 用户信息获取 ---> 设置已登录；用户信息未获取 ---> 未登录(登录故障)
// 3. 是否打开过实名框 --> 未打开走4(跳转过realname.auth.html页面，或认为打开过pc端弹出过框，或已实名过)，已打开保持
// 4. 走实名框，设置已打开过 -->跳转到目标s_url路径
// 报名
// 6. 点击报名 --> 未登录 --> 走1（已登录) --> 点击-->跳转问卷
// 7. 点击报名 --> 已登录 --> 跳转到问卷.
